import { mediaItems } from '@/mocks/media';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500 mt-1">独家专访、幕后花絮、音乐MV</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
            共 4 个视频
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-background-300 transition-colors group cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/25 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-[10px] bg-black/60 text-white px-1.5 py-0.5 rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] bg-accent-500 text-background-50 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views}播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}